import React, { useState } from 'react';
import { WindowCalculator } from './components/WindowCalculator';
import { CustomerComparison } from './pages/CustomerComparison';
import type { SynchronyOption } from './components/pricingUtils';
export interface ComparisonData {
  productLine: string;
  selectedFrameColor: string;
  selectedExteriorColor: string;
  totalBasePrice: number;
  totalAdderCost: number;
  grandTotal: number;
  discountPercent: number;
  discountAmount: number;
  totalDue: number;
  totalWindowCount: number; // represents total items (windows + doors)
  totalSqFt: number;
  financingCompany: string;
  synchronyOption: SynchronyOption | null;
}
export function App() {
  const [comparisonData, setComparisonData] = useState<ComparisonData | null>(null);
  const showingComparison = comparisonData !== null;
  return <>
      <div style={{
      display: showingComparison ? 'none' : 'block'
    }} data-id="element-0">
        <WindowCalculator onShowComparison={data => setComparisonData(data)} data-id="element-1" />
      </div>
      {showingComparison && <CustomerComparison data={comparisonData} onBack={() => setComparisonData(null)} data-id="element-2" />}
    </>;
}